"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deconstruct = exports.inr = exports.inl = void 0;
var inl = function (l) { return ({ kind: "l", v: l }); };
exports.inl = inl;
var inr = function (r) { return ({ kind: "r", v: r }); };
exports.inr = inr;
var deconstruct = function (onL, onR, v) { return v.kind == "l" ? onL(v.v) : onR(v.v); };
exports.deconstruct = deconstruct;
